// extracted by mini-css-extract-plugin
module.exports = {"feedback":"styles_feedback__Oegg7","desc":"styles_desc__3Q2NE"};